import { getLogger } from '../logging/functions';
const DEFAULT_OPTS = {};
const DEFAULT_RN_OPTS = { disableCallerInfo: true };
const opts = navigator.product === 'ReactNative' ? DEFAULT_RN_OPTS : DEFAULT_OPTS;
// @ts-ignore
export default getLogger('features/base/redux', undefined, opts);
